import PropTypes from "prop-types"

import InvestorShape from "./InvestorShape"
import CustomerShape from "./CustomerShape"
import OrganizationShape from "./OrganizationShape"


const AccountShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  tagIds: PropTypes.arrayOf(PropTypes.string),
  investor: InvestorShape.isRequired,
  sponsorId: PropTypes.string,
  customers: PropTypes.arrayOf(CustomerShape),
  isImmutable: PropTypes.bool,
  is2FaEnabled: PropTypes.bool,
  brokerUserId: PropTypes.string,
  organization: OrganizationShape,
  organizations: PropTypes.arrayOf(OrganizationShape),
})

export default AccountShape
